import { execSync } from 'child_process'
import os from 'os'
import type { CommandHandlerFn } from '../command-handler'

export function createProcessHandlers(): Record<string, CommandHandlerFn> {
  return {
    'process:list': processList,
    'process:kill': processKill,
    'service:list': serviceList,
    'service:restart': serviceRestart,
  }
}

async function processList(params?: { sort?: string }) {
  const platform = os.platform()
  try {
    if (platform === 'win32') {
      const output = execSync('tasklist /FO CSV /NH', { encoding: 'utf-8' })
      return parseProcessWindows(output)
    } else {
      const output = execSync('ps aux --sort=-%mem', { encoding: 'utf-8' })
      return parseProcessUnix(output, params?.sort)
    }
  } catch {
    return []
  }
}

function parseProcessUnix(output: string, _sort?: string) {
  const lines = output.trim().split('\n').slice(1)
  return lines.slice(0, 100).map((line) => {
    const parts = line.trim().split(/\s+/)
    return {
      pid: parseInt(parts[1]),
      name: parts[10] || parts[parts.length - 1],
      cpu: parseFloat(parts[2]),
      memory: parseInt(parts[5]) * 1024,
      user: parts[0],
      started: parts[8],
    }
  })
}

function parseProcessWindows(output: string) {
  return output.trim().split('\n').filter(Boolean).slice(0, 100).map((line) => {
    const parts = line.replace(/"/g, '').split(',')
    return {
      pid: parseInt(parts[1]),
      name: parts[0],
      cpu: 0,
      memory: parseInt(parts[4]?.replace(/[^0-9]/g, '')) || 0,
      user: '',
      started: '',
    }
  })
}

async function processKill(params?: { pid: number; signal?: string }) {
  if (!params?.pid) throw new Error('缺少 pid 参数')
  const signal = params.signal || 'SIGTERM'
  try {
    process.kill(params.pid, signal as NodeJS.Signals)
    return { success: true }
  } catch (err: any) {
    return { success: false, error: err.message }
  }
}

async function serviceList() {
  try {
    const output = execSync('pm2 jlist 2>/dev/null', { encoding: 'utf-8' })
    const services = JSON.parse(output)
    return services.map((s: any) => ({
      name: s.name,
      status: s.pm2_env?.status === 'online' ? 'online' : s.pm2_env?.status === 'stopped' ? 'stopped' : 'errored',
      pid: s.pid,
      uptime: s.pm2_env?.pm_uptime ? Math.floor((Date.now() - s.pm2_env.pm_uptime) / 1000) : undefined,
      restarts: s.pm2_env?.restart_time || 0,
      memory: s.monit?.memory,
      cpu: s.monit?.cpu,
    }))
  } catch {
    return []
  }
}

async function serviceRestart(params?: { name: string }) {
  if (!params?.name) throw new Error('缺少 name 参数')
  try {
    execSync(`pm2 restart ${params.name} 2>/dev/null`, { encoding: 'utf-8' })
    return { success: true }
  } catch {
    return { success: false }
  }
}
